/**
 * 档案管理 终端维护
 */
<template>
  <div>
    <!-- 面包屑导航 -->    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">档案管理</el-breadcrumb-item>
      <el-breadcrumb-item>终端维护</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formParameter" class="user-search" @submit.native.prevent>
    <!--  <el-form-item  label="终端指令：">
        <el-input placeholder="请输入终端指令" v-model="formParameter.terminalCode"  size="small"></el-input>
      </el-form-item> -->

			<el-form-item label="终端名称/终端代码：">
			  <el-input placeholder="请输入终端名称/终端代码"  @keyup.enter.native="search"  v-model="formParameter.terminalName" size="small" ></el-input>
			</el-form-item>
      <el-form-item v-if="user.username == 'admin'">
        <el-select v-model="getJZ" placeholder="请选择" @change="handleNodeClick" size="small">
           <el-option
             v-for="item in deptData"
             :key="item.id"
             :label="item.departmentName"
             :value="item.id">
           </el-option>
         </el-select>
      </el-form-item>
      <el-form-item >
        <el-select size="small" v-model="formParameter.onlineStatus" placeholder="请选择状态" @change="changeType" clearable >
           <el-option label="在线" value="1"></el-option>
           <el-option label="离线" value="0"></el-option>
         </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
				<prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="dept:add"  @click="handleEdit" label="添加" />
      </el-form-item>
    </el-form>
		<el-row style="margin-bottom: 10px;">
			<!-- <el-button size="mini" type="danger"  :disabled="!currIds.length">删除选中</el-button> -->

		 <!-- <prems-button size="mini" type="danger"  perms="dept:deleted"   label="删除选中"  style="float: left; margin-right: 10px;"/> -->


			<el-upload
				action=""
				multiple
				:http-request="importData"
				:show-file-list="false"
				style="float: left;"
			>
			<prems-button size="mini" icon="el-icon-upload2"   perms="dept:import"  :loading="loadLoadin"  label="导入" />
			</el-upload>


		</el-row>

    <!--列表-->
    <el-table :header-cell-style="this.$store.state.headerCss" size="small" :max-height="tableHeight" :data="listData" @selection-change="handleSelectionChange"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column align="center" label="序号" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="terminalName" label="终端名称"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="terminalCode" label="终端地址" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column v-if="isNan"   label="状态" width="120">
        <template slot-scope="scope">
          <el-tag size="mini" type="success" v-if="scope.row.isOnline">在线</el-tag>
          <el-tag size="mini" type="info" v-if="!scope.row.isOnline">离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column  prop="protocolType" label="规约类型" width="120" show-overflow-tooltip>
     </el-table-column>

      <el-table-column  prop="collectScheme" label="采集方案" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="channelName" label="通道名称" width="120" show-overflow-tooltip>
      </el-table-column>
    <!--  <el-table-column  prop="ipAddress" label="IP地址" width="180" show-overflow-tooltip>
      </el-table-column> -->
			 <el-table-column  prop="createDate" label="创建时间" width="140" show-overflow-tooltip>
      </el-table-column>

     <!--  <el-table-column  prop="manufacturer" label="生产厂商" width="140" show-overflow-tooltip>
      </el-table-column>
     <el-table-column  prop="equipmentType" label="设备型号" width="120" show-overflow-tooltip>
      </el-table-column>-->

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope" style="display: flex;">
          <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
          <prems-button size="mini" type="text "   perms="dept:zd" @click="handelData(scope.row)"  label="数据召读" />
          <prems-button size="mini" type="text " perms="dept:fx" @click="handelFx(scope.row)"  label="防窃电分析" />


          <el-dropdown style="padding-left: 20px;" trigger="click" v-if="showMoreSet">
            <span class="el-dropdown-link" style="font-size: 12px;">
             更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="mdropdown">
              <div><prems-button size="mini" type="text"   perms="dept:zd" @click="showAuth(scope.row)" label="初始化" /></div>
              <div><prems-button size="mini" type="text "   perms="dept:xf" @click="handelXf(scope.row)"  label="下发" /></div>
              <div><prems-button size="mini" type="text " :loading="loadJl && scope.row.id == curid"   perms="dept:zd" @click="handelJl(scope.row)"  label="计量点参数召读" /></div>
              <div><prems-button size="mini" type="text"  perms="dept:deleted"  @click="handleDelete(scope.$index, scope.row)" label="删除" /></div>
            </el-dropdown-menu>
          </el-dropdown>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-if="showPage" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" :close-on-click-modal="false">
      <el-form label-width="120px" :model="currData" ref="editForm" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="终端名称" prop="terminalName">
              <el-input size="small" v-model="currData.terminalName" auto-complete="off" placeholder="请输入名称" ></el-input>
            </el-form-item>
            <el-form-item label="终端地址" prop="terminalCode">
              <el-input size="small" v-model="currData.terminalCode" auto-complete="off" placeholder="请输入集中器地址" ></el-input>
            </el-form-item>
            <el-form-item label="规约类型" prop="protocolType">

							 <el-select size="small" v-model="currData.protocolType" placeholder="请选择" style="width:100%">
									<el-option v-for="item in protocolTypeList" :key="item.value" :label="item.label":value="item.value"></el-option>
								</el-select>

            </el-form-item>
						<el-form-item label="采集方案" prop="collectScheme">
							<el-select size="small" v-model="currData.collectScheme" placeholder="请选择" style="width:100%">
								<el-option v-for="item in collectSchemeList" :key="item.value" :label="item.label":value="item.value"></el-option>
							</el-select>

						</el-form-item>
						<el-form-item label="通道名称" prop="channelName">
							<el-select size="small" v-model="currData.channelName" placeholder="请选择" style="width:100%">
								<el-option v-for="item in channelNameList" :key="item.value" :label="item.label":value="item.value"></el-option>
							</el-select>
						</el-form-item>


            <el-form-item label="设备地址">
              <el-input size="small" v-model="currData.equipmentAddress" auto-complete="off" placeholder="请输入设备地址	" ></el-input>
            </el-form-item>

            <el-form-item label="生产厂商" prop="manufacturer">

							<el-select size="small" v-model="currData.manufacturer" placeholder="请选择" style="width:100%">
								<el-option v-for="item in manufacturerList" :key="item.value" :label="item.label":value="item.value"></el-option>
							</el-select>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备型号">
              <el-input size="small" v-model="currData.equipmentType" auto-complete="off" placeholder="请输入设备型号" ></el-input>
            </el-form-item>
            <el-form-item label="主机号">
              <el-input size="small" v-model="currData.hostNumber" auto-complete="off" placeholder="请输入主机号" ></el-input>
            </el-form-item>
            <el-form-item label="sim卡号">
              <el-input size="small" v-model="currData.simNumber" auto-complete="off" placeholder="请输入sim卡号" ></el-input>
            </el-form-item>
            <el-form-item label="安装地点">
              <el-input size="small" v-model="currData.installationSite" auto-complete="off" placeholder="请输入安装地点" ></el-input>
            </el-form-item>
             <el-form-item label="ip地址">
             <el-input size="small" v-model="currData.ipAddress" auto-complete="off" placeholder="请输入ip地址" ></el-input>
           </el-form-item>
           <el-form-item label="ip端口">
             <el-input size="small" v-model="currData.ipPort" auto-complete="off" placeholder="请输入ip端口" ></el-input>
           </el-form-item>
					 <el-form-item label="选择企业" size="small"  prop="departmentStr" >
					  <el-cascader
						style="width:100%"
					  	v-model="getDeptData"
					  	ref="depsCascader"
					  	:options="deptData"
					  	:props="{ expandTrigger: 'click',children:'deps',label:'departmentName',checkStrictly: true,value:'id'}"
					  	@change="handleChange">
					  </el-cascader>
					 </el-form-item>
          </el-col>
        </el-row>

      </el-form>
			<div slot="footer" class="dialog-footer">
			  <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<prems-button size="small" type="primary" :loading="saveLoad"   perms="dept:upDate"  @click="handleSave" label="保存" />
			</div>
    </el-dialog>

    <el-dialog title="数据召读" :visible.sync="dataVisble" width="85%" class="sjzd" top="8vh"  :close-on-click-modal="false" @close="closeSend">
       <el-form inline>
         <el-form-item label="请求类型">

           <el-select v-model="datatype" placeholder="请选择" size="small" style="width:160px" @change="getDataItems">
             <el-option label="实时数据" :value="1"></el-option>
             <el-option label="历史数据"  :value="2"></el-option>
             <el-option label="防窃电数据" :value="3" v-if="isNw"></el-option>


           </el-select>
         </el-form-item>
         <el-form-item label="信息类型" style="margin-left: 10px;">
           <el-select v-model="msgType" placeholder="请选择" size="small" style="width:160px">
             <el-option
               v-for="item in msgOpt"
               :key="item.value"
               :label="item.label"
               :value="item.value">
             </el-option>
           </el-select>


         </el-form-item>

         <el-form-item v-if="datatype ==3">
           <el-button style="margin-left: 10px;" type="warning" size="small" @click="handelSetQd">配置防窃电</el-button>
         </el-form-item>

         <el-form-item style="float: right;">
           <el-button v-if="datatype!=3" size="small" type="primary" :loading="loadCall" @click="handCall">召读</el-button>
           <el-button  v-if="datatype ==3" size="small" type="primary" :loading="loadCall" @click="handCallQieDian">召读</el-button>
           <el-button  v-if="datatype ==3" size="small" type="primary"  :disabled="isLoadAll"  @click="handCallAll">开盖记录召读全部</el-button>
           <el-button  v-if="datatype ==3" size="small" type="success"  @click="getZdReslut">查看结果</el-button>
         </el-form-item>

         <el-form-item style="float: right;margin-right: 20px;">
          <el-checkbox-group v-model="checkList" @change="getStype" v-if="user.name == 'admin' ">
            <el-checkbox label="1"  v-if="datatype != 3">入ES库</el-checkbox>
            <el-checkbox label="2" v-if="datatype != 3" >入windows库</el-checkbox>

          </el-checkbox-group>

         </el-form-item >
         <el-form-item style="float: right;margin-right: 20px;" v-if="datatype != 3">
           <el-switch v-model="showbw" active-color="#13ce66" active-text="查看报文"></el-switch>
         </el-form-item>
       </el-form>

       <el-row :gutter="30" style="margin-top: 10px;">
         <el-col :span="12">
          <div  >
           <div style="display: flex;  align-items: center;">
            <h3 style="margin-right: 20px;">选择数据项</h3>
            <div>
              <el-form inline>
                <el-form-item >
                  <el-input size="small" v-model="dinName" placeholder="请输入数据项" @input="getDataItems"></el-input>
                </el-form-item>
               <el-form-item  v-if="datatype == 2">
                  <el-date-picker
                   v-model="startTime"
                   type="date"
                   value-format="yyyy-MM-dd"
                   size="small" style="width:140px"
                   placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>
           </div>
           <el-table border size="small" stripes :data="dataItems" height="240" @selection-change="getDins" v-loading="loadItems" :header-cell-style="this.$store.state.headerCss">


              <el-table-column align="center" type="selection" width="50"></el-table-column>
              <el-table-column prop="din" label="标识" width="130">
                <template slot-scope="scope">
                  <el-input size="mini"  v-if="scope.row.id == 0" v-model="scope.row.din" @change="chageDins"></el-input>
                  <p v-if="scope.row.protocolType == 0">{{scope.row.bmType}}</p>
                  <p v-if="scope.row.protocolType == 1" >{{scope.row.din}}</p>
                </template>
              </el-table-column>
              <el-table-column  label="数据项">
                <template slot-scope="scope">
                  <p v-if="scope.row.protocolType == 0">{{scope.row.itemName}}</p>
                  <p v-if="scope.row.protocolType == 1" >{{scope.row.din_name}}</p>
                </template>
              </el-table-column>
           </el-table>
          </div>

         </el-col>
         <el-col :span="12">
           <div style="display: flex; justify-content: space-between; align-items: center;line-height: 54px;">
            <div><el-button type="primary" size="small" @click="showJl">添加计量点</el-button></div>
           </div>

           <el-table border size="small" stripes :data="getJlDatas" height="240"  :header-cell-style="this.$store.state.headerCss" >
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column prop="meterPointName" label="计量点名称"></el-table-column>
              <el-table-column prop="meterPoint" label="计量点地址" width="120"></el-table-column>
              <el-table-column prop="terminalNumber" label="计量点终端内编码" width="120"></el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="delJls(scope.row)" icon="el-icon-delete"></el-button>

                </template>
              </el-table-column>

           </el-table>
         </el-col>
       </el-row>
       <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 10px;" v-if="isNw">

         <h3>召读结果</h3>
         <div style="flex: 1;padding: 0 30px;"> <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage" status="success"></el-progress></div>
         <div style="display: flex; align-items: center;">
           <div style="margin-left:20px">召读总数：<span style="color: #409EFF;">{{resultNum.total}}</span></div>
           <div style="margin-left:20px">召读成功：<span style="color: #67C23A;">{{resultNum.success}}</span></div>
           <div style="margin-left:20px">召读失败：<span style="color: #F56C6C;">{{resultNum.fail}}</span></div>
           <div style="margin-left:20px">等待召读：<span style="color: #E6A23C;">{{resultNum.wait}}</span></div>
         </div>

       </div>

       <el-table v-if="isNw" :data="resultList" border stripe size="small" height="300px" :row-class-name="tableRowClassName" :header-cell-style="this.$store.state.headerCss">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="name" label="计量点名称" width="200" ></el-table-column>
          <el-table-column prop="pn" label="计量点终端内编码" width="160"></el-table-column>
          <el-table-column prop="rtuAddr" label="终端地址"  width="160"></el-table-column>
          <el-table-column prop="itemName"  label="数据项" width="140"></el-table-column>
          <el-table-column  label="数据值">
            <template slot-scope="scope">
              <div v-if="datatype != 3 ">{{scope.row.stringValue}}</div>
              <el-popover
                v-if="datatype == 3 "
                placement="left"
                width="300"
                trigger="hover">
                <div>
                  <p v-for="item in scope.row.stringValue.split(';')">{{item}}</p>
                </div>
                <p slot="reference" class="stringValue">{{scope.row.stringValue}}</p>
              </el-popover>
            </template>

          </el-table-column>
          <el-table-column v-if="showbw" prop="msgReceive" label="上行报文" min-width="200" show-overflow-tooltip=""></el-table-column>
          <el-table-column v-if="showbw" prop="msgSend" label="下行报文" min-width="200" show-overflow-tooltip=""></el-table-column>
       </el-table>

       <el-table v-if="!isNw"  style="margin-top: 6px;" :data="resultGwList" v-loading="loadCall" border stripe size="small" height="300px" :row-class-name="tableRowClassName" :header-cell-style="this.$store.state.headerCss">
             <el-table-column type="index" width="50"></el-table-column>
             <el-table-column prop="name" label="计量点" width="200" ></el-table-column>
             <el-table-column prop="itemName" label="数据项" width="200" ></el-table-column>
             <el-table-column prop="simpleStringValue" label="值" width="160"></el-table-column>
             <el-table-column prop="di" label="di"  width="80"></el-table-column>
             <el-table-column prop="diN"  label="diN" width="200"></el-table-column>
             <el-table-column prop="occtime" label="数据项返回值"></el-table-column>
            <!-- <el-table-column v-if="showbw" prop="msgReceive" label="上行报文" min-width="200" show-overflow-tooltip=""></el-table-column>
             <el-table-column v-if="showbw" prop="msgSend" label="下行报文" min-width="200" show-overflow-tooltip=""></el-table-column> -->
          </el-table>

    </el-dialog>



    </el-dialog>



    <el-dialog title="防窃电配置" :visible.sync="qdSetVisble" :close-on-click-modal="false" >
      <div class="qeidian">
        <el-form label-width="100px" label-position="left">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="端口号">
                <el-input size="small" v-model="qieDianFormData.dk" style="width: 100%;"></el-input>
              </el-form-item>
              <el-form-item label="波特率">
                <el-select size="small" v-model="qieDianFormData.btl" style="width: 100%;">
                  <el-option label="2400" value="08"></el-option>
                  <el-option label="1200" value="04"></el-option>
                  <el-option label="600" value="02"></el-option>
                  <el-option label="300" value="01"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="中继类型">
                <el-select  v-model="qieDianFormData.type" size="small" style="width: 100%;">
                  <el-option label="转发对终端的抄读" value="00"></el-option>
                  <el-option label="转发主站对电能表的拉闸" value="01"></el-option>
                  <el-option label="转发主站对电能表的合闸" value="02"></el-option>
                  <el-option label="转发主站对电能表的保电投入" value="03"></el-option>
                  <el-option label="转发主站对电能表的保电解" value="04"></el-option>
                  <el-option label="转发主站对电能表抄读" value="0A"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="超时时间(秒)">
                <el-input size="small" v-model="qieDianFormData.cssj"></el-input>
              </el-form-item>
            </el-col >

            <el-col :span="12">
              <el-form-item label="校验位" >
                <el-select v-model="qieDianFormData.jyfs" size="small" style="width: 100%;">
                  <el-option label="无校验" value="00"></el-option>
                  <el-option label="偶校验" value="01"></el-option>
                  <el-option label="奇校验" value="02"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数据位" v-model="qieDianFormData.sjw" >
                <el-select v-model="qieDianFormData.sjw" size="small" style="width: 100%;">
                  <el-option label="5" value="05"></el-option>
                  <el-option label="6" value="06"></el-option>
                  <el-option label="7" value="07"></el-option>
                  <el-option label="8" value="08"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="停止位" >
                <el-select v-model="qieDianFormData.tzw" size="small" style="width: 100%;">
                  <el-option label="1位" value="00"></el-option>
                  <el-option label="1.5位" value="01"></el-option>
                  <el-option label="2位" value="02"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary"  @click='qdSetVisble = false'>确认</el-button>

      </div>
    </el-dialog>


    <el-dialog title="选择计量点" :visible.sync="jlVisble" :close-on-click-modal="false">
      <div style="width: 300px;margin-bottom: 14px;">
        <el-input size="small" placeholder="请输入关键词" @input="getMeterListByInput" prefix-icon="el-icon-search" v-model="searchStr"></el-input>
      </div>
      <el-table border size="small" stripes :data="jlDatas" height="350" v-loading="loadMeters" @selection-change="getJls"  ref='bindTable'>
         <el-table-column align="center" type="selection" width="50"></el-table-column>
         <el-table-column prop="meterPointName" label="计量点名称"></el-table-column>
         <el-table-column prop="meterPoint" label="计量点地址" ></el-table-column>
         <el-table-column prop="terminalNumber" label="计量点终端内编码"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='jlVisble = false'>取消</el-button>
        <el-button size="small" type="primary" @click="addJls">确认</el-button>

      </div>

    </el-dialog>


    <el-dialog title="数据下发" :visible.sync="xfVisble"  width="60%" :close-on-click-modal="false" @close="closeSend">

      <el-form inline >
        <el-form-item label="搜索:">
           <el-input size="small" placeholder="请输入关键词" @input="getMeterListByInput" prefix-icon="el-icon-search" v-model="searchStr"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" :disabled="pns.length == 0" type="warning" @click="sendData">下发</el-button>
        </el-form-item>
      </el-form>

      <el-table border size="small" stripes :data="jlDatas" height="350" v-loading="loadMeters" @selection-change="getSendPns"  ref='bindTable'>
         <el-table-column align="center" type="selection" width="50"></el-table-column>
         <el-table-column prop="meterPointName" label="计量点名称"></el-table-column>
         <el-table-column prop="meterPoint" label="计量点地址" ></el-table-column>
         <el-table-column prop="terminalNumber" label="计量点终端内编码" ></el-table-column>
         <el-table-column prop="communicationProtocol" label="通讯规约" ></el-table-column>
         <el-table-column prop="communicationType" label="通讯方式" ></el-table-column>
         <el-table-column prop="communicationRate" label="通讯速率" ></el-table-column>
         <el-table-column label="下发结果"  width="160">
           <template slot-scope="scope">
             <el-tag size="mini" v-if="scope.row.status == 1" type="info">准备下发</el-tag>
             <el-tag size="mini" v-if="scope.row.status == 2" type="primary" ><i class="el-icon-loading" style="margin-right: 2px;"></i> 等待下发</el-tag>
             <el-tag size="mini" v-if="scope.row.status == 3" type="success">下发成功</el-tag>
             <el-tag size="mini" v-if="scope.row.status == 4" type="danger">{{scope.row.errMsg}}</el-tag>
             <el-tag size="mini" v-if="scope.row.status == 5" type="danger">终端离线</el-tag>
           </template>
         </el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='xfVisble = false'>取消</el-button>

      </div>

    </el-dialog>

    <el-dialog title="召读结果" :visible.sync="zdVisble"  width="60%" :close-on-click-modal="false" @close="zdVisble = false">
      <el-table border size="small" stripes :data="resList" height="350" v-loading="loadMeters" @selection-change="getSendPns"  ref='bindTable'>
         <el-table-column align="center" type="index" width="50"></el-table-column>
         <el-table-column prop="startTime" label="开始时间"></el-table-column>
         <el-table-column prop="endTime" label="结束时间" ></el-table-column>
        <el-table-column label="状态"  width="160">
          <template slot-scope="scope">
           <div v-if="scope.row.end">
             <el-tag v-if="scope.row.success" type="success" size="mini">执行成功</el-tag>
             <el-tag v-else type="danger" size="mini">执行失败</el-tag>
           </div>
           <div v-else>
             <el-tag  type="primary" size="mini">执行中</el-tag>
           </div>
          </template>
        </el-table-column>
         <el-table-column label="操作"  width="240">
           <template slot-scope="scope">
             <el-button size="small" type="primary" @click="getQdList(scope.row.elePreventionSet,scope.row.id)" >查看防窃电数据</el-button>
             <el-button size="small" type="primary" @click="buzhao(scope.row.id)">补召数据</el-button>
           </template>
         </el-table-column>

      </el-table>
      <Pagination v-bind:child-msg="zdPageParam" @callFather="getZdResulListByPage"></Pagination>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='zdVisble = false'>取消</el-button>

      </div>

    </el-dialog>
    <el-dialog title="防窃电数据" :visible.sync="qdVisble"  width="60%" :close-on-click-modal="false" @close="qdVisble = false">
      <el-button size="small" :loading="loadDwonLoad" type="success" @click="exportData()" >导出</el-button>
      <el-table border size="small" stripes :data="qdList" style="margin-top: 20px;" >
         <el-table-column align="center" type="index" width="50"></el-table-column>
         <el-table-column prop="meterPointName" label="计量点" ></el-table-column>
         <el-table-column  label="开盖次数" >
           <template slot-scope="scope">
             <span >{{scope.row.count}}</span>
           </template>
         </el-table-column>
         <el-table-column prop="createTime" label="时间"></el-table-column>
         <el-table-column label="数据值" >
           <template slot-scope="scope">
             <el-popover
                placement="left"
                width="300"
                trigger="hover">
                <div>
                  <p v-for="item in scope.row.simpleStringValue.split(';')">{{item}}</p>
                </div>
                <span slot="reference" class="stringValue">{{scope.row.simpleStringValue}}</span>
              </el-popover>
           </template>
         </el-table-column>

         <el-table-column label="是否补召">
           <template slot-scope="scope">
              <el-tag v-if="scope.row.buZhao" size="mini">是</el-tag>
              <el-tag v-else size="mini" type="warning">否</el-tag>
           </template>
         </el-table-column>


      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='qdVisble = false'>取消</el-button>
      </div>

    </el-dialog>

    <el-dialog title="初始化终端" :visible.sync="initVisibel" width="400px" :close-on-click-modal="false">
      <el-form >
        <el-form-item label="选择类型">
          <el-select size="small" v-model="resetParam">
            <el-option label="所有可写的参数恢复出厂设置" value="00"></el-option>
            <el-option label="数据区复位" value="01"></el-option>
            <el-option label="终端硬件" value="02"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="saveInit" :loading="loadInit">确定</el-button>
        <el-button size="small" @click='initVisibel = false'>取消</el-button>
      </div>
    </el-dialog>


    <!-- 管理员确认 对话框 -->
    <el-dialog  title="管理员授权" :visible.sync="gVisible" width="420px" :close-on-click-modal="false">

      <el-form label-width="65px" :model="checkForm" :rules="cRules" ref="geditForm">

        <el-form-item label="账号：" prop="username">
          <el-input size="small"  style="width:240px" v-model="checkForm.username" placeholder="请输入管理员账号"></el-input>
        </el-form-item>

        <el-form-item label="密码：" prop="password" >
          <el-input type="password" size="small" style="width:240px"  placeholder="请输入管理员密码" v-model="checkForm.password"></el-input>
        </el-form-item>
      </el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="gVisible = false">取 消</el-button>
    		<el-button size="mini" type="primary" @click="checkSwitch" :loading="loadSwitch">确 定</el-button>
    	</div>
    </el-dialog>



    <el-dialog title="分析执行天数" :visible.sync="daysVisible" width="400px" :close-on-click-modal="false">
      <el-form inline label-width="80">
        <el-form-item label="选择天数">
          <el-select size="small" v-model="fxDays">
            <el-option :value="1"></el-option>
            <el-option :value="2"></el-option>
            <el-option :value="3"></el-option>
            <el-option :value="4"></el-option>
            <el-option :value="5"></el-option>
            <el-option :value="6"></el-option>
            <el-option :value="7"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
      	<el-button size="mini" @click="daysVisible = false">取消</el-button>
      	<el-button size="mini" type="primary" @click="startFx" >确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog  title="防窃电分析" :visible.sync="qdfx" :close-on-click-modal="false" >

      <div class="fx-header">
        <div class="no-fx" v-if="!tStatus">
          <div class="n-title">
            <img src="../../assets/img/fx.png" style="margin-right: 10px;" />
            还未对防窃电进行分析
          </div>
          <div>
            <el-button  type="primary" size="small" @click="daysVisible = true">立即分析</el-button>
          </div>
        </div>
        <div   class="is-fx" v-if="tStatus">
          <div v-if="tStatus < 5">分析中</div>
          <div v-if="tStatus == 5">分析完成</div>
          <div>
            <el-progress :percentage="snum"></el-progress>
          </div>
         <!-- <p>已用时间：00:40:22</p> -->
        </div>
        <div v-if="tStatus == 5 " style="margin-top: 20px;">
           <el-button  type="primary" size="small" @click="daysVisible = true">重新分析</el-button>
        </div>

      </div>

      <div class="fx-content">
        <div class="fx-item" :class="getTaskStatusClass(1)">
          <div class="item-header">
            <p class="step">1</p>
          </div>
          <div class="item-center">
            <img v-if="tStatus == 0" src="../../assets/img/i1.png" />
            <img v-else src="../../assets/img/i1a.png" />
            <p>日冻结</p>
          </div>
          <div class="item-footer">
            <p class="defatlt wStatus" v-if="tStatus == 0" >等待分析</p>
            <p class="defatlt rStatus" v-if="tStatus == 1" ><i class="el-icon-loading icon" style="font-size:20px"></i>分析中</p>
            <p class="defatlt fStatus" v-if="tStatus > 1" ><i class="el-icon-check icon" style="font-size:20px"></i>已完成</p>
          </div>
        </div>
        <div class="fx-item" :class="getTaskStatusClass(2)">
          <div class="item-header">
            <p class="step">2</p>
          </div>
          <div class="item-center">
            <img v-if="tStatus < 2" src="../../assets/img/i2.png" />
            <img v-else src="../../assets/img/i2a.png" />
            <p>开盖记录</p>
          </div>
          <div class="item-footer">
            <p class="defatlt wStatus" v-if="tStatus < 2" >等待分析</p>
            <p class="defatlt rStatus" v-if="tStatus == 2" ><i class="el-icon-loading icon" style="font-size:20px"></i>分析中</p>
            <p class="defatlt fStatus" v-if="tStatus > 2" ><i class="el-icon-check icon" style="font-size:20px"></i>已完成</p>
          </div>
        </div>
        <div class="fx-item" :class="getTaskStatusClass(3)">
          <div class="item-header">
            <p class="step">3</p>
          </div>
          <div class="item-center">

            <img v-if="tStatus < 3" src="../../assets/img/i3.png" />
            <img v-else src="../../assets/img/i3a.png" />

            <p>零火线电流</p>
          </div>
          <div class="item-footer">
           <p class="defatlt wStatus" v-if="tStatus < 3" >等待分析</p>
           <p class="defatlt rStatus" v-if="tStatus == 3" ><i class="el-icon-loading icon" style="font-size:20px"></i>分析中</p>
           <p class="defatlt fStatus" v-if="tStatus > 3" ><i class="el-icon-check icon" style="font-size:20px"></i>已完成</p>
          </div>
        </div>
        <div class="fx-item" :class="getTaskStatusClass(4)">
          <div class="item-header">
            <p class="step">4</p>
          </div>
          <div class="item-center">
            <img v-if="tStatus < 4" src="../../assets/img/i4.png" />
            <img v-else src="../../assets/img/i4a.png" />
            <p>有功功率</p>
          </div>
          <div class="item-footer">
            <p class="defatlt wStatus" v-if="tStatus < 4" >等待分析</p>
            <p class="defatlt rStatus" v-if="tStatus == 4" ><i class="el-icon-loading icon" style="font-size:20px"></i>分析中</p>
            <p class="defatlt fStatus" v-if="tStatus > 4" ><i class="el-icon-check icon" style="font-size:20px"></i>已完成</p>
          </div>
        </div>
      </div>


      <div class="fx-total">
        <div class="total-item"  @click="getDateValue(1)">日冻结-共<span style="color:#fda719">{{freeTotal}}</span>项</div>
        <div class="total-item"  @click="getKaiGaiValue(true)">开盖记录-共<span style="color:#fda719">{{abroachTotal}}</span>项  第{{ eleCounts }}次执行</div>
        <div class="total-item" @click="getLinHuoValue(true)" >零火线电流-共<span style="color:#fda719">{{zeroFiringTotal}}</span>项  第{{ eleCounts }}次执行</div>
        <div class="total-item" @click="getYouGong(true)">有功功率-共<span style="color:#fda719">{{powerTotal}}</span>项  第{{ eleCounts }}次执行</div>
      </div>

      <div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="qdfx = false">取 消</el-button>
    		<!-- <el-button size="mini" type="primary" @click="checkSwitch" :loading="loadSwitch">确 定</el-button> -->
    	</div>
    </el-dialog>

    <el-dialog  :title="resTitle" :visible.sync="resTitleVisible"  :close-on-click-modal="false">
      <el-form size="small" inline v-if="fType == 1">


        <el-form-item label="选择差值">
          <el-select v-model="diffValue" placeholder="请选择" size="small" style="margin-bottom: 10px;" :disabled="isAllRi">
            <el-option value="100"></el-option>
            <el-option value="500"></el-option>
            <el-option value="1000"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="查看所有数据">
          <el-switch v-model="isAllRi" @change="handelAll"></el-switch>
        </el-form-item>
      </el-form>

      <!-- 日冻结有问题数据 -->
      <el-table v-if="fType == 1 && !isAllRi" border size="small" stripes :data="rdata" height="350" :row-class-name="twarning" >
         <el-table-column align="center" type="index" width="50"></el-table-column>
         <el-table-column prop="meterInfoName" label="计量点名称"></el-table-column>
         <el-table-column prop="meterPoint" label="计量点地址" ></el-table-column>
         <el-table-column prop="totalValue" label="用量"></el-table-column>


      </el-table>


      <!-- 日冻结所有数据 -->
      <div class="rtatle">
        <el-table v-if="fType == 1 && isAllRi" border size="small" stripes :data="allRiData" height="350" >
           <el-table-column align="center" type="index" width="50" ></el-table-column>
           <el-table-column prop="meterInfoName" label="计量点名称" width="130"></el-table-column>
           <el-table-column label="计量点数据" >
            <el-table-column width="120" v-for="item in dCol" :label="item.value" :prop="item.port">

            </el-table-column>
           </el-table-column>

        </el-table>
      </div>




      <!-- 开盖记录数据 -->

     <el-form v-if="fType != 1" inline>
       <el-form-item label="选择执行次数">
         <el-input-number size="mini" v-model="eleCounts" :max="maxConunt" :min="1"></el-input-number>
       </el-form-item>
       <el-form-item>
         <el-button size="mini" type="primary" @click="getFxValueByCounts">确认</el-button>
       </el-form-item>
     </el-form>

      <el-table v-if="fType == 2" border size="small" stripes :data="kgData" height="350" >
         <el-table-column align="center" type="index" width="50"></el-table-column>
         <el-table-column prop="count" label="开盖次数"></el-table-column>
         <el-table-column prop="meterPointName" label="计量点"></el-table-column>
         <el-table-column  label="数据值">
           <template slot-scope="scope">

             <el-popover

               placement="left"
               width="300"
               trigger="hover">
               <div>
                 <p v-for="item in scope.row.simpleStringValue.split(';')">{{item}}</p>
               </div>
               <p slot="reference" class="stringValue">{{scope.row.simpleStringValue}}</p>
             </el-popover>
           </template>

         </el-table-column>
      </el-table>


      <!-- 零火线数据 -->
      <el-table v-if="fType == 3 || fType == 4" border size="small" stripes :data="linHuoData" height="350" :row-class-name="jilu"  >
         <el-table-column align="center" type="index" width="50"></el-table-column>

         <el-table-column prop="meterPointName" label="计量点"></el-table-column>
         <el-table-column prop="AEle" label="A相功率"></el-table-column>
         <el-table-column prop="BEle" label="B相功率"></el-table-column>
         <el-table-column prop="CEle" label="C相功率"></el-table-column>
         <el-table-column prop="zeroEle" label="零线功率"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='resTitleVisible = false'>取消</el-button>
       <!-- <el-button size="small" type="primary" @click="addJls">确认</el-button> -->

      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/vuex/store'
import {
	getTerminalInfoList,
	getAllConfigurationList,
	terminalInfoAdd,
	terminalInfoUpdate,
	terminalInfoDelete,
	uploadTerm,
  getDinList,
  findItemListByName,
  ifGWOrNW,
  findMeterListByCall,
  newDataCall,
  freezeDataCall,
  meterParamSend,
  sendRelayFrame,
  sendRelayFrameCall,
  getElePreventionTaskList,
  getElePreventionTaskFile,
  reset,
  sendRelayFrameCallNew,
  CheckSwitchAdmin,
  getMeterInfoParam,
  findTask,
  findEnergyFreezeList,
  findTaskDownList,
  findAbroachList,
  findEEleHardPowerDataList,
  sendRelayFrameCallTask,
  findFreezeDateList,
  newGWDataCall,
  freezeGWDataCall

} from '../../api/energyMG'
import { departmentList } from '../../api/userMG'
import { timestampToTime } from '../../utils/util.js'
import Pagination from '../../components/Pagination'
import PremsButton from "@/views/permission/PreButtom";

export default {
  data() {
		var validatePass = (rule, value, callback) => {
        if (this.currData.departmentStr === '') {
          callback(new Error('请选择企业部门'));
        } else {
          callback();
        }
     };
     var validateUsers = (rule, value, callback) => {
         if (this.checkForm.username != 'admin') {
           callback(new Error('账号错误！'));
         } else {
           callback();
         }
      };

    return {
      zdparam : {

      },
      isNw:1,
      isAllRi:false,
      allRiData:[],
      dCol:[],
      maxConunt:0,
      fxDays:3,
      fxTerId:"",
      linHuoData:[],
      diffValue:100,
      fType:1,
      rdata:[],//日冻结数据
      kgData:[],//开盖记录数据
      resTitle:"",
      resTitleVisible:false,
      freeTotal: 0,
      abroachTotal: 0,
      zeroFiringTotal: 0,
      powerTotal: 0,
      tStatus:0,
      taskId:30,
      qdfx:false,
      gVisible:false,
      zdVisble:false,
      qdVisble:false,
      showPage:true,
      snum:0,
      resetParam:"00",
      qieDianFormData:{
        dk:'00',
        jyfs:"01",
        sjw:"08",
        tzw:"00",
        btl:"08",
        cssj:"15",
        type:"00",
        rtuAddr:"",
        meterAddr:""
      },
      resultGwList:[],
      terminalName:"",
      curid:"",
      loadSwitch:false,
      qdList:[],
      resList:[],
      isNan:false,
      loadItems:false,
      checkList:[],
      tempJls:[],
      xfVisble:false,
      jlVisble:false,
      loadCall:false,
      startTime:"",
      depId:'',
      terminalId:"",
      pn:'',//终端内编码
      dis:[],
      zdtype:false,
      cRules:{

        username:[{validator:validateUsers,trigger:'blur'}],
        password:[{required:true,message:'请输入管理员密码',trigger:'blur'}]
      },
      pns:[],
      sendBreak:false,
      saveLoad:false,
      checkForm:{
        username:'',
        password:""
      },
      qdSetVisble:false,
      showbw:false,
      densityType:6,
      resultList:[],
      resultNum:{
        total:0,
        success:0,
        fail:0,
        wait:0
      },
      rtuAddr:"",
      zdResust:[],
      zdFailList:[],
      jlDatas:[],
      getJlDatas:[],
      dataItems:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      dataVisble:false,
      loadMeters:false,
      user:{},
      getJZ:"",
      currJzId:'',
      datatype:1,
      daysVisible:false,
      dinName:"",
      tableHeight:0,
      saveType:"",
      currData: {
				 terminalName : "",
				 terminalCode : "",
				 protocolType :"",
				 equipmentAddress:"",
				 collectScheme:"",
				 channelName:"",
				 ipAddress:"",
				 ipPort:"",
				 manufacturer:"",
				 equipmentType:"",
				 hostNumber:"",
				 simNumber:"",
				 installationSite:""

			},
      isCheck:false,
      loadGw:false,
			rules: {
				 terminalName :[
					{ required: true, message: '请输入终端名称', trigger: 'blur' },
				 ],
         terminalCode:[
					{ required: true, message: '请输入终端地址', trigger: 'blur' },
				 ],
				 protocolType:[
					{ required: true, message: '请选择规约类型', trigger: 'change' },
				 ],
				 collectScheme:[
					{ required: true, message: '请选择采集方案', trigger: 'change' },
				 ],

				 manufacturer:[
					{ required: true, message: '请选择生产厂商', trigger: 'change' },
				 ],
				 equipmentAddress:[
					 { required: true, message: '请输入设备地址', trigger: 'blur' },
				 ],
				 channelName:[
					 { required: true, message: '请选择通道名称', trigger: 'change' },
				 ],
				 departmentStr:[
					 { required: true,  validator:validatePass, trigger: 'change' },
				 ]

			},
      tid:'',
      loadDwonLoad:false,
			loadLoadin:false,
      formParameter: {
        currentPage:1,
				pageSize:10,
				terminalName:'',
				terminalCode:'',
        departmentId:'',
        onlineStatus:"",

      },
      requestOpt:[
        {value:1,label:"实时数据"},
        {value:2,label:"历史数据"},
        {value:3,label:"防窃电数据"},
        // {value:3,label:"三类数据"},
        // {value:4,label:"任务数据"},

      ],
      msgType:1,
      msgOpt:[
        {value:1,label:'计量点'},
        {value:2,label:'终端'},
      ],
      mdOpt:[

        {value:15,label:"15分钟"},
        {value:30,label:"30分钟"},
        {value:60,label:"60分钟"},
        {value:5,label:"5分钟"}
      ],



			currIds:[],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      showMoreSet:false,
      userparm: [], //搜索权限
      listData: [], //用户数据
			protocolTypeList:[],//规约类型集合
			collectSchemeList:[],//采集方案集合
			channelNameList:[], //通道名称集合
			manufacturerList:[],//生产厂商集合
			deptData:[],//所属部门
			getDeptData:[],
      percentage:0,
      loadJl:false,
      isLoadAll:false,
      searchStr:"",
      initVisibel:false,
      eleCounts:0,

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total:0
      },
      loadInit:false,
      zdPageParam:{
        currentPage: 1,
        pageSize: 10,
        total:0
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
		PremsButton
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    let perms = store.state.perms
    for(let i=0, len=perms.length; i<len; i++) {
        if(perms[i] === 'dept:zd' || perms[i] === 'dept:xf' || perms[i] === 'dept:deleted') {
            this.showMoreSet = true;
            break
        }
    }

    this.user = JSON.parse(sessionStorage.getItem('userdata'))
    this.getJZ = this.user.departmentName
    this.formParameter.departmentId = this.user.departmentId
    this.getdata(this.formParameter)
		this.getConfigData();
		this.getdept()
   let d = new Date()
   let preDate = new Date(d .getTime() - 24*60*60*1000)
   this.startTime = timestampToTime(preDate).substring(0,10)


  },
  mounted(){
    this.$nextTick(() => {

    	this.tableHeight = window.innerHeight - 280
    })
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    handelAll(){
      if(this.isAllRi){
        this.getAllRiData()
      }
    },

    getAllRiData(){
      let param = {
        taskId:this.taskId,
        terId:this.fxTerId
      }
      findFreezeDateList(param).then(res =>{
        if(res.status == 1){
          this.allRiData = res.data.data
          this.dCol = res.data.header
        }

        console.log(this.allRiData[0].meterInfoName)

      })
    },

    startFx(){
      let param = {
        terId:this.fxTerId,
        rtuAddr:this.rtuAddr,
        days:this.fxDays,
        depId:this.getJZ,
        terminalName:this.terminalName
      }

      sendRelayFrameCallTask(param).then(res=>{
        if(res.status == 1){
          this.$message.success("操作成功！")
          this.daysVisible = false
          this.tStatus = 1
          this.freeTotal = 0,
          this.abroachTotal = 0,
          this.zeroFiringTotal = 0,
          this.powerTotal = 0,
          this.snum = 0
          this.eleCounts = 0
        }else{
          this.$message.error(res.msg)
        }
      })

    },

    twarning({row, rowIndex}){

      if(row.diff > parseInt(this.diffValue)){
        return 'w-row'
      }else{
        return 'hide'
      }
    },
    jilu(){
      return 'w-row'
    },

    //根据执行次数获取 开盖记录、零火线，有功功率
    getFxValueByCounts(){
      if(this.fType == 2){
        this.getKaiGaiValue()
      }else if(this.fType == 3){
        this.getLinHuoValue()
      }else if(this.fType == 4){
        getYouGong()
      }
    },



    //零火线数据
    getLinHuoValue(init){
      this.fType = 3
      this.resTitleVisible = true
      this.resTitle = '零火线数据'
      if (init){ this.eleCounts = this.maxConunt }
      let param = {
        dataType:1,
        taskId:this.taskId,
        taskCount:this.eleCounts
      }
      findEEleHardPowerDataList(param).then(res=>{
        if(res.status == 1){
           this.linHuoData = res.data.data
        }
      })
    },
    getYouGong(init){
      this.fType = 4
      this.resTitleVisible = true
      this.resTitle = '有功功率'
      if (init){ this.eleCounts = this.maxConunt }
      let param = {
        dataType:2,
        taskId:this.taskId,
        taskCount:this.eleCounts
      }
      findEEleHardPowerDataList(param).then(res=>{
        if(res.status == 1){
           this.linHuoData = res.data.data
        }
      })
    },

    getKaiGaiValue(init){
       this.fType = 2
       this.resTitleVisible = true
       this.resTitle = '开盖记录'
       if (init){ this.eleCounts = this.maxConunt }
       let param = {
         taskId:this.taskId,
         taskCount:this.eleCounts
       }
       findAbroachList(param).then(res=>{
         if(res.status == 1){
           this.kgData = res.data.data
         }
       })
    },


    //查看日冻结数据
    getDateValue(i){
      this.fType = i
      this.resTitle = '日冻结数据'
      this.resTitleVisible = true
      let param ={
        taskId:this.taskId,
        terId:this.fxTerId,
      }
      findEnergyFreezeList(param).then(res => {
        if(res.status == 1){
          let tempData = res.data.data
          if(tempData.length){
            for(let i = 0;i<tempData.length;i++){
              let lastData = tempData[i+1] ? tempData[i+1].totalValue : 0
              tempData[i].diff = Math.abs(lastData - tempData[i].totalValue).toFixed(2)
            }
          }
          this.rdata = tempData
        }
      })
    },

    getTaskStatusClass(i){
      if( this.tStatus < i){
        return 'waiting'
      }else if( this.tStatus == i){
        return 'runing'
      }else if( this.tStatus > i ){
        return 'finsh'
      }
    },

    handelFx(row){
      this.qdfx = true
      this.rtuAddr = row.terminalCode
      this.fxTerId = row.id
      this.getTaskStatus(row)

    },

    getFxTotal(taskId,terId){
      let param = {
        taskId:taskId,
        terId:terId
      }
      findTaskDownList(param).then(res=>{
        if(res.status == 1){
          this.freeTotal = res.data.freeTotal
          this.abroachTotal = res.data.abroachTotal
          this.zeroFiringTotal = res.data.zeroFiringTotal
          this.powerTotal = res.data.powerTotal
        }
      })
    },

    //查看当前任务
    getTaskStatus(row){
      let param = {
        terId:row.id
      }
      this.terminalName = row.terminalName
      findTask(param).then(res => {
        if(res.status == 1){
          if(res.data){
            this.tStatus = res.data.eleStatus || 1
            this.taskId = res.data.id
            this.eleCounts = res.data.eleCounts
            this.maxConunt = res.data.eleCounts
            this.snum = (this.tStatus-1)/4 * 100
            this.getFxTotal(this.taskId,row.id)
          }else{
            this.tStatus = 0
          }
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    handelJl(row){


      this.curid = row.id

      let param = {
        commAddress:row.terminalCode,
        terminalInfoId:row.id
      }
      this.zdparam = param
      this.gVisible = true
      this.zdtype = true

    },


    jldCall(){
      this.loadJl = true
      getMeterInfoParam(this.zdparam).then(res => {
         this.loadJl = false
         if(res.status == 1){
           this.$message.success("操作成功！")
         }else{
           this.$message.error(res.msg)
         }
      })
    },



    //补召数据
    buzhao(id){
      sendRelayFrameCallNew({taskId:id}).then(res => {
        if(res.status == 1){
          this.$message.success("操作成功！")
          this.getZdReslut()
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    checkSwitch(){
      this.$refs['geditForm'].validate( val =>{
        CheckSwitchAdmin(this.checkForm).then(res => {
          if(res.status == 1){

            this.gVisible = false
            this.isCheck = true
            if(this.zdtype){
              this.jldCall()
            }else{
              this.initVisibel = true
            }
             this.zdtype = false
          }else{
            this.$message.error(res.msg)
             this.zdtype = false
          }

        })
      })
    },

    handelSetQd(){
      this.qdSetVisble = true
    },


    showAuth(row){

      this.gVisible = true
      this.rtuAddr = row.terminalCode
    },

    saveInit(){
      let param = {
        rtuAddr:this.rtuAddr,
        resetParam:this.resetParam
      }
      this.loadInit = true
      reset(param).then(res => {
        this.loadInit = false
        if(res.status == 1){
          this.$message.success('操作成功！')
          this.initVisibel = false
        }else{
           this.$message.error(res.msg)
        }
      })
    },

    showJl(){
      this.jlVisble = true
    },

    closeZD(){
       done();
    },

    exportData(){
      let param = {
        taskId:this.tid,
        rtuAddr:this.rtuAddr
      }
      this.loadDwonLoad = true
      getElePreventionTaskFile(param).then(res=>{
          this.loadDwonLoad = false
          var blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
        	var downloadElement = document.createElement('a');
        　　var href = window.URL.createObjectURL(blob); //创建下载的链接
        　　downloadElement.href = href;
        　　downloadElement.download = 'result.xls'; //下载后文件名
        　　document.body.appendChild(downloadElement);
        　　downloadElement.click(); //点击下载
        　　document.body.removeChild(downloadElement); //下载完成移除元素
        　　window.URL.revokeObjectURL(href); //释放掉blob对象
        	this.downloadJlLoadin = false
        	this.$message.success('表格生成成功！正在下载')
        }).catch(err => {
        	this.downloadJlLoadin = false
        	this.$message({
        		message:'下载失败！',
        		type:'error',
        		showClose:true
        	})
        })

    },
    getQdList(data,tid){
      this.qdVisble = true
      this.tid = tid
      this.qdList = data

    },
    getZdResulListByPage(parm){
      this.zdPageParam.currentPage = parm.currentPage
      this.zdPageParam.pageSize = parm.pageSize
      this.getZdReslut()
    },

    getZdReslut(){
      this.zdVisble = true
      let param = {
        depId:this.depId,
        terminalId:this.currJzId
      }
      getElePreventionTaskList({...this.zdPageParam,...param}).then(res => {
        if(res.status == 1){
          this.resList = res.data.data
          this.zdPageParam.total = res.data.totalCount
        }
      })

    },
    handCallAll(){
      let param = {
        depId:this.depId,
        terminalId:this.currJzId
      }
      this.$message.info('召读全部命令以下发，请稍后点击查看结果')
      this.isLoadAll = true
      sendRelayFrameCall(param).then(res => {
        this.isLoadAll = false
        if(res.status != 1 ){
          this.$message.error(res.msg)
        }
      })
    },

    //显示下发
    handelXf(row){
      this.pns = []
      this.xfVisble = true
      this.currJzId = row.id
      this.sendBreak = false
      this.getMeterListByCall()
      this.rtuAddr = row.terminalCode //获取集中器地址
    },

    closeSend(){
      this.sendBreak  = true
      this.isLoadAll = false
      if( this.$store.state.cancelRequest  ){
         let cancel = this.$store.state.cancelRequest
         cancel('interrupt')
      }
    },

    async sendData(){
      this.jlDatas.forEach((item,idx) => {
        if(item.status){
           this.jlDatas[idx].status = 2
           this.$set(this.jlDatas,idx,this.jlDatas[idx])
        }
      })


       for( let pn of this.pns){

         if(this.sendBreak){
           break
         }
         let param = {
           pn:pn.pn,
           rtuAddr:this.rtuAddr,
           para:{
             e0800000:pn.e0800000 ? '01':'00',
             e080000a:pn.e080000a,
             e0800002:pn.e0800002,
             e0800003:pn.e0800003,
             e0800001:pn.e0800001,
             e0800004:pn.e0800004,
             e0800005:pn.e0800005,
             e0800006:pn.e0800006,
             e0800007:pn.e0800007 ? '01':'00',
             e0800008:pn.e0800008,
             e0800009:pn.e0800009,
             e080000c:pn.e080000c,
             e080000d:pn.e080000d,
             e080000b:pn.e080000bss+pn.e080000bdd+pn.e080000bpp+pn.e080000bbb
           },
           meterPoint:pn.meterPoint,
           // pointPort:pn.pointPort,
         }

         param.para = JSON.stringify(param.para)
         await this.requestSendData(param).then( (res)=>{
             this.chagenStatus(3,param)
         }).catch(err=>{
           this.jlDatas.forEach((item,idx) => {
             if(item.meterPoint == param.meterPoint){
                this.jlDatas[idx].status = 4
                this.jlDatas[idx].errMsg = err
                this.$set(this.jlDatas,idx,this.jlDatas[idx])
             }
           })
         })
       }
    },

    chagenStatus(type,param){
      this.jlDatas.forEach((item,idx) => {
        if(item.meterPoint == param.meterPoint){
           this.jlDatas[idx].status = type
           this.$set(this.jlDatas,idx,this.jlDatas[idx])
        }
      })
    },

    getPointPort(val){
      if(val == '485-1'){
        return '00'
      }else if(val == '485-2'){
        return '01'
      }else if(val == '载波'){
        return '31'
      }
    },

    //参数下发
    requestSendData(param){
       return new Promise((resolve,reject) =>{
          meterParamSend(param).then(res => {
            if(res.status == 1 ){
              resolve()
            }else{
              reject(res.msg)
            }
          })
       })

    },
    //数据召读数据项
    getDataItems(){
      this.loadItems = true
      let param = {
        dinType:this.datatype,
        dinName:this.dinName,
        rtuAddr:this.rtuAddr
      }
      findItemListByName(param).then(res => {
        this.loadItems = false
        if(res.status == 1){
          this.dataItems = res.data
        }else{
          this.$message.error(res.msg)
        }

        if(this.datatype == 3){
          this.dataItems.unshift({
            id:0,
            din:'050601',
            din_name:'上n次日冻结正向有功总'

          })
        }
      })
    },

    changeType(){
      this.formParameter.currentPage = 1
      this.getdata(this.formParameter)
    },

    // 获取集中器信息
    getdata(parameter) {
      this.loading = true

      getTerminalInfoList(parameter)
        .then(res => {
          this.loading = false
          if (res.status == 1) {
						  this.listData = res.data.data
							this.pageparm.total = res.data.totalCount
              if(JSON.stringify(res.data.data[0].isOnline) == 'null'){
                this.isNan = false
              }else{
                this.isNan = true
              }
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.loading = false
        })
    },
		handleSelectionChange:function(e){
			this.currIds = e.map( item => item.id)
		},

    // 分页插件事件
    callFather(parm) {
      this.formParameter.currentPage = parm.currentPage
      this.formParameter.pageSize = parm.pageSize
      this.getdata(this.formParameter)
    },
    // 搜索事件
    search() {
      this.showPage = false
      this.formParameter.currentPage  = 1
      this.getdata(this.formParameter)
      this.$nextTick(() => {
        this.showPage = true
      })
    },

    getDins(data){
      if(this.isNw == 1){
        this.dis = data.map(item => item.din)
      }else{
        this.dis = data.map(item => item.bmType)
      }

    },

    chageDins(val){
     this.dis[0] = val
    },

    getSendPns(val){

      this.pns = val.map(item => {

        return {
          pn:item.terminalNumber,
          name:item.meterPointName,
          meterPoint:item.meterPoint,
          pointPort:this.getPointPort(item.communicationType),

          e0800000:item.isRunning || '',
          e080000a:item.communicationType || '',
          e0800002:item.meterPoint || '',
          e0800003:item.communicationProtocol || '',
          e0800001:item.be0800001 || '',
          e0800004:item.be0800004 || '',
          e0800005:item.be0800005 || '',
          e0800006:item.be0800006 || '',
          e0800007:item.be0800007 || '',
          e0800008:item.be0800008 || '',
          e0800009:item.be0800009 || '',
          e080000c:item.be080000c || '',
          e080000d:item.be080000d || '',
          e080000bbb:item.be080000bbb || '',
          e080000bdd:item.be080000bdd || '',
          e080000bpp:item.be080000bpp || '',
          e080000bss:item.be080000bss || '',
        }
      })

      this.jlDatas.forEach(item => {
        item.status = null
        item.errMsg = ''
        val.forEach(sitem => {

          if(sitem.meterPoint  == item.meterPoint){
            item.status = 1
            item.errMsg = ''
          }
        })
      })
    },
    getPns(){
      this.pns = this.getJlDatas.map(item => {
        return {
          pn:item.terminalNumber,
          name:item.meterPointName,
          meterPoint:item.meterPoint
        }
      })

    },

    getJls(data){
      this.tempJls = data

    },
    addJls(){
      let arr = this.getJlDatas.concat(this.tempJls)
      this.getJlDatas = Array.from(new Set(arr))
      this.tempJls = []
      this.jlVisble = false
      this.$refs.bindTable.clearSelection();

    },
    delJls(e){
    	this.getJlDatas = this.getJlDatas.filter(item => item.id != e.id)
    },

    getStype(e){

      this.checkList = [e[e.length-1]]
      this.saveType = this.checkList.join(',')
    },

    handCall(){

      this.resultNum.total = 0
      this.resultNum.success = 0
      this.resultNum.fail = 0
      this.resultNum.wait = 0
      this.getPns()

      //国网召读不能超过四个
      if(!this.isNw && this.pns.length > 4){
        this.$message.warning('计量点数量不能超过4个~')
         return
      }
      if(this.dis.length == 0){
        this.$message.warning('请选择数据项')
        return
      }
      if(this.pns.length == 0){
         this.$message.warning('请选择计量点')
         return
      }
      this.percentage = 0
      this.resultList = []
      if(this.datatype == 1){
        this.callRealTime()
      }else if(this.datatype == 2){

        this.callHistory()
      }
    },


    handCallQieDian(){

      if(this.dis.length == 0){
        this.$message.warning('请选择数据项')
        return
      }
      this.getPns()
      if(this.pns.length == 0){
         this.$message.warning('请选择计量点')
         return
      }



      this.resultNum.total = 0
      this.resultNum.success = 0
      this.resultNum.fail = 0
      this.resultNum.wait = 0

      this.qieDianFormData.rtuAddr = this.rtuAddr


      this.percentage = 0
      this.resultList = []
      this.callQieDian()


    },


    //循环防窃电数据
    async callQieDian(){


      let l = this.dis.length * this.pns.length
      this.resultNum.total = l



      let step = 0
      let s = 0
      let w = l
      let f = 0

      for( let  di of this.dis ){
        if( this.sendBreak){ break}
        for (let item of this.pns){
          if( this.sendBreak){ break}
          this.qieDianFormData.meterAddr = item.meterPoint
          this.qieDianFormData.relayDi = di
          this.qieDianFormData.pns = item.pn,
          this.qieDianFormData.saveType = this.saveType,
          this.loadCall = true
          await this.requestQieDian(item).then(res => {
             this.resultNum.success = ++s
          }).catch(err => {
             this.resultNum.fail = ++f
          })
          step++
          this.resultNum.wait = --w
          this.percentage = parseInt((step/l*100).toFixed(2))
          if(step == l){ this.loadCall = false }
        }
      }

    },

    //请求防窃电
    requestQieDian(pn){
     return new Promise((resolve,reject) =>{
      sendRelayFrame(this.qieDianFormData).then(res => {
        if(res.status == 1){
          let resultObj = {}
          resultObj.name = pn.name
          resultObj.pn = pn.pn
          resultObj.rtuAddr = this.rtuAddr

          let resData =  res.data.pnValueMap[0] || res.data.pnValueMap[pn.pn]

          resultObj.stringValue = resData.dataList[0].simpleStringValue
          resultObj.itemName = resData.dataList[0].itemName
          this.resultList.push( resultObj )
          resolve()
        }else{
          let failObj = {}
          failObj.name = pn.name
          failObj.pn = pn.pn
          failObj.fail = true
          failObj.stringValue = res.msg
           failObj.rtuAddr = this.rtuAddr
          this.resultList.push( failObj )
          reject()
        }
      })
     })
    },



    //循环历史数据召读
    async callHistory(){

      //南网循环历史召读
      if(this.isNw){
        let l = this.dis.length * this.pns.length
        this.resultNum.total = l
        let step = 0
        let s = 0
        let w = l
        let f = 0
        for( let  di of this.dis ){
          if( this.sendBreak){ break}
          for( let pn of this.pns){
            if( this.sendBreak){ break}
            let param = {
              rtuAddr:this.rtuAddr,
              pnList:pn.pn.split(','),
              fnList:di.split(','),
              saveType:this.saveType,
              startTime:this.startTime,
            }
            this.loadCall = true

            await this.requestHistoryCall(param,pn).then(res=>{
               this.resultNum.success = ++s
            }).catch(err=>{
              this.resultNum.fail = ++f
            })
            step++
            this.resultNum.wait = --w
            this.percentage = parseInt((step/l*100).toFixed(2))
            if(step == l){ this.loadCall = false }
          }
        }
      }else{

        this.requestGWHistoryCall()
      }


    },

    //南网同步多次请求历史数据召读
    requestHistoryCall(param,pn){

      return new Promise((resolve,reject) =>{
        freezeGWDataCall(param).then(res => {
          if(res.status == 1){
            let resultObj = res.data.pnValueMap[pn.pn].dataList[0]
            resultObj.name = pn.name
            resultObj.pn = pn.pn
            resultObj.rtuAddr = this.rtuAddr
            resultObj.msgReceive = res.data.msgReceive
            resultObj.msgSend = res.data.msgSend
            this.resultList.push( resultObj )
            resolve()
          }else if(status == 0){
            let failObj = {}
            failObj.name = pn.name
            failObj.pn = pn.pn
            failObj.fail = true
            failObj.stringValue = res.msg
            failObj.msgSend = res.data ? res.data.msgSend : ''
            failObj.rtuAddr = this.rtuAddr
            this.resultList.push( failObj )
            reject()
          }

        })
      })
    },

    //国网一次请求历史数据召读
    requestGWHistoryCall(  ){
      this.loadCall = true
      let param =  {
        rtuAddr:this.rtuAddr,
        pnList:this.pns.map(item => item.pn),
        fnList:this.dis,
        saveType:this.saveType,
        startTime:this.startTime
      }
      freezeGWDataCall(param).then(res => {
        this.loadCall = false
        if(res.status == 1){
          this.$message.success('操作成功！')
          let arr = []
          let tempArr = res.data.pnValueMap

          Object.getOwnPropertyNames(tempArr).forEach(key =>{
            this.pns.map(item => item.pn).forEach(pn => {
              if(pn == key){
                tempArr[key].dataList.forEach(item => {
                  this.dis.forEach(di => {
                    if(item.diN == di){
                      item.name = this.pns.filter(item => item.pn == pn)[0].name
                      arr.push(item)
                    }
                  })
                })
              }
            })
          })

          this.resultGwList = arr
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    //实时数据召读
    //国网不需要去循环直接把数组传到后台
    async callRealTime(){

      //南网循环召读数据
      if(this.isNw){
        let l = this.dis.length * this.pns.length
        this.resultNum.total = l
        let step = 0
        let s = 0
        let w = l
        let f = 0

        for( let  di of this.dis ){
          for( let pn of this.pns){
            let param = {
              fnList:di.split(','),
              pnList:pn.pn.split(','),
              saveType:this.saveType,
              rtuAddr:this.rtuAddr
            }
            this.loadCall = true
            await this.requestRealCall(param,pn).then(res=>{
               this.resultNum.success = ++s
            }).catch(err=>{
              this.resultNum.fail = ++f
            })
            step++
            this.resultNum.wait = --w
            this.percentage = parseInt((step/l*100).toFixed(2))
            if(step == l){ this.loadCall = false }
          }
        }
      }else{
        //国网召读实时数据

        this.requestGwRealCall()
      }

    },

    //国网实时数据召读
    requestGwRealCall(){
      this.loadCall = true

      let param = {
        rtuAddr:this.rtuAddr,
        pnList:this.pns.map(item => item.pn),
        fnList:this.dis,
        saveType:this.saveType
      }
      newGWDataCall(param).then(res => {
        this.loadCall = false
        if(res.status == 1){
          this.$message.success('操作成功！')

          let arr = []
          let tempArr = res.data.pnValueMap

          Object.getOwnPropertyNames(tempArr).forEach(key =>{
            this.pns.map(item => item.pn).forEach(pn => {
              if(pn == key){
                tempArr[key].dataList.forEach(item => {
                  this.dis.forEach(di => {
                    if(item.diN == di){
                      item.name = this.pns.filter(item => item.pn == pn)[0].name
                      arr.push(item)
                    }
                  })
                })
              }
            })
          })
          this.resultGwList = arr
          this.resultGwList = arr

        }else{
          this.$message.error(res.msg)
        }
      })
    },
    requestRealCall(param,pn){
      return new Promise((resolve,reject) =>{
        newGWDataCall(param).then(res => {
          if(res.status == 1){
            let resultObj = res.data.pnValueMap[pn.pn].dataList[0]
            resultObj.name = pn.name
            resultObj.pn = pn.pn
            resultObj.msgReceive = res.data.msgReceive
            resultObj.msgSend = res.data.msgSend
            resultObj.rtuAddr = this.rtuAddr
            this.resultList.push( resultObj )
            resolve()
          }else if(status == 0){
            let failObj = {}
            failObj.name = pn.name
            failObj.pn = pn.pn
            failObj.fail = true
            failObj.stringValue = res.msg
            failObj.rtuAddr = this.rtuAddr
            failObj.msgSend = res.data ? res.data.msgSend : ''
            this.resultList.push( failObj )
            reject()
          }

        })
      })
    },
    //显示数据召读
    handelData(row){
      this.dataVisble = true
      this.loadCall = false
      this.sendBreak = false
      this.currJzId = row.id
      this.rtuAddr = row.terminalCode
      this.percentage = 0
      this.datatype = 1
      this.checkList = []
      this.resultGwList = []
      this.saveType = ''
      this.pns = []
      let d = new Date()
      let preDate = new Date(d .getTime() - 24*60*60*1000)
      this.startTime = timestampToTime(preDate).substring(0,10)
      this.getJlDatas = []
      this.resultList = []
      this.dinName = ''
      this.qieDianFormData.dk = '00'
      this.qieDianFormData.jyfs = "01"
      this.qieDianFormData.sjw = "08"
      this.qieDianFormData.tzw = "00"
      this.qieDianFormData.btl = "08"
      this.qieDianFormData.cssj = "15"
      this.qieDianFormData.type = "00"
      this.qieDianFormData.rtuAddr = ""
      this.qieDianFormData.meterAddr = ""
      this.qieDianFormData.relayDi = ""
	    this.getProtocolType()
      this.getDataItems()
      this.getMeterListByCall()
    },


    getProtocolType(){
     ifGWOrNW({rtuAddr:this.rtuAddr}).then(res => {
       if(res.status == 1){

         this.isNw = res.data.protocolType
       }
     })
    },

    getMeterListByInput(){
      setTimeout(() => {
        this.getMeterListByCall()
      },500)
    },
    getMeterListByCall(){
      this.loadMeters = true
      let param = {
        terId:this.currJzId,
        search:this.searchStr,
        energyType:15
      }

      findMeterListByCall(param).then(res => {
        this.loadMeters = false
        if(res.status == 1){
          this.jlDatas = res.data
        }
      })
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true

			 if (row != undefined && row != 'undefined') {
				 this.title = '修改'
				 this.currData.id = row.id
				 this.currData.terminalName = row.terminalName || ""
				 this.currData.terminalCode = row.terminalCode || ""
				 this.currData.protocolType = row.protocolType || ""
				 this.currData.equipmentAddress= row.equipmentAddress || ""
				 this.currData.collectScheme= row.collectScheme || ""
				 this.currData.channelName= row.channelName || ""
				 this.currData.ipAddress= row.ipAddress || ""
				 this.currData.ipPort= row.ipPort || ""
				 this.currData.manufacturer= row.manufacturer || ""
				 this.currData.equipmentType= row.equipmentType || ""
				 this.currData.hostNumber= row.hostNumber || ""
				 this.currData.simNumber= row.simNumber || ""
				 this.currData.installationSit= row.installationSit || ""
				 this.currData.departmentStr = row.departmentId || ""
				 this.getDeptData[0] = row.departmentId || ""
			 }else{
				 this.title = '添加'
         this.currData.id = ""
				 this.currData.terminalName = "",
				 this.currData.terminalCode = "",
				 this.currData.protocolType = "",
				 this.currData.equipmentAddress= "",
				 this.currData.collectScheme= "",
				 this.currData.channelName= "",
				 this.currData.ipAddress= "",
				 this.currData.ipPort= "",
				 this.currData.manufacturer= "",
				 this.currData.equipmentType= "",
				 this.currData.hostNumber= "",
				 this.currData.simNumber= "",
				 this.currData.installationSit= "",
				 this.currData.departmentStr = ""
				 this.getDeptData = []
			 }
    },

		handleChange(e){
			let id = e[e.length-1]
			this.currData.departmentStr = id
		},
	  handleSave:function(){
			this.$refs['editForm'].validate((valid) => {
				  if (valid) {
							if(this.title == '添加'){
								this.dataSave()
							}else{
								this.dataUpdate()
							}
					}else{
						return false;
					}
			});
		},
		dataSave:function(){
      this.saveLoad = true
			terminalInfoAdd(this.currData).then(res => {
        this.saveLoad = false
				if(res.status == 1){
					this.$message.success('添加成功！')
					this.editFormVisible = false
				  this.getdata(this.formParameter)
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		dataUpdate:function(){
       this.saveLoad = true
			terminalInfoUpdate(this.currData).then(res => {
        this.saveLoad = false
				if(res.status == 1){
					this.$message.success('修改成功！')
					this.editFormVisible = false
				  this.getdata(this.formParameter)
				}else{
					this.$message.error(res.msg)
				}
			})
		},

		importData:function(val){
			this.loadLoadin = true
			let  formData = new FormData();
			formData.append('file', val.file);
			uploadTerm(formData).then( res=> {
				this.loadLoadin = false
				if(res.status == 1){
					this.$message.success(res.msg)
					this.getdata(this.formParameter)
				}else{
					this.$message.error(res.msg)
				}
			})
		},

	//获取所有的部门信息

		getdept(){
			departmentList().then(res => {
				if(res.status == 1){
					this.deptData = res.data
				}else{
					this.$message.error(res.msg)
				}
			})
			.catch(err => {
			  this.loading = false
			  this.$message.error('获取部门信息失败，请稍后再试！')
			})
		},

		//获取所有配置选项
		getConfigData(){
			getAllConfigurationList().then(res => {
				if(res.status == 1){

					this.protocolTypeList = res.data.protocolType
					this.collectSchemeList = res.data.collectScheme
					this.channelNameList = res.data.channelName
					this.manufacturerList = res.data.manufacturer
				}
			})

		},
    handleNodeClick(data){
      this.formParameter.departmentId = data
      this.depId = data
      // this.search();
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formParameter)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          terminalInfoDelete({id:row.id})
            .then(res => {
              if (res.status == 1) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formParameter)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })

        })

    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      // this.$refs[formName].resetFields()
    },
     tableRowClassName({row, rowIndex}) {
      if (row.fail) {
        return 'warning-row';
      }
      return '';
    }
  }
}
</script>

<style >
  .mdropdown .el-button{
    padding: 10px 20px;
  }
  .rtatle >>> .el-table__header-wrapper{
    height: 80px;
  }
  .rtatle >>> .el-table__body-wrapper{
    height: calc(100% - 80px ) !important;
  }
  .w-row{
    color: red;
  }
  .hide{
    display: none;
  }
  .fx-total{
    padding-top: 14px;
  }
  .total-item{
      cursor: pointer;
      line-height: 40px;
      padding-left: 4px;
      font-size: 14px;
      border-bottom: 1px solid #f2f1f1;
  }
   .total-item:hover{
     background: #f4f4f4;
   }
  .total-item span{
    padding: 0 6px;
  }
  .item-footer .icon{
    position: relative;
    top:3px;
  }
  .wStatus{ color:  }
  .rStatus{ color: #79bbff  }
  .fStatus{ color: #fda719 }

.item-center{
  height: 150px;
  background: #d8d8d8;
  text-align: center;
  overflow: hidden;
}
.finsh .item-center{
  background: #fda719;
  color: #fff;
}
.runing .item-center{
  background: #79bbff;
  color: #fff;
}
.item-center img{
  display: inline-block;
  margin-top: 42px;
}
.item-footer{
  text-align: center;
  color: #e1e1e1;
  font-size: 14px;
  line-height: 40px;
}
.item-header{
  height: 52px;
  border-top: 3px solid #d8d8d8;
  position: relative;
}
.finsh .item-header{
  border-top: 3px solid #fda719;
}
.runing .item-header{
  border-top: 3px solid #79bbff;
}
.item-header .step{
  width: 42px;
  height: 42px;
  border: 1px solid #fff;
  background: #d8d8d8;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  font-size: 18px;
  line-height: 42px;
  position: absolute;
  left: 50%;
  top: -40px;
  margin-left: -21px;
}

.finsh .item-header .step{
  background: #fda719;
}
.runing .item-header .step{
  background: #79bbff;
}
.fx-content{
  display: flex;
  margin-top: 20px;
}
.fx-item{
  flex: 1;
  margin: 0 6px;
  height: 276px;
  border: 1px solid #d8d8d8;
  border-top: 0;

}
.no-fx{
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.n-title{
  display: flex;
  line-height: 70px;
  color: #b6b6b6;
  align-items: center ;
}
.n-title img{
  display: inline-block;
}
.sjzd .el-form-item{
  margin-bottom: 4px;
  margin-right: 0;
}
.warning-row{
  color: #F56C6C;
}
.qeidian{
  padding-top: 50px;
}
.sjzd .qeidian .el-form-item{
  margin-bottom: 10px;
}
.stringValue{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/archives/weihu.vue